"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Modal = _interopRequireDefault(require("./Modal.style"));

var _Label = _interopRequireDefault(require("../Label"));

var _dec, _class;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

let Modal = (_dec = (0, _reactJss.default)(_Modal.default), _dec(_class = class Modal extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this.transitionEnd = this.transitionEnd.bind(this);
    this.onModalClick = this.onModalClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  static getDerivedStateFromProps(props) {
    if (!props.visibility) {
      return {
        mountStyle: false
      };
    }

    return {
      show: true
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.visibility && this.state.show) {
      setTimeout(() => this.setState({
        mountStyle: true
      }), 10);
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
  }

  transitionEnd() {
    const {
      visibility
    } = this.props;

    if (!visibility) {
      this.setState({
        show: false
      });
    }
  }

  onModalClick(e) {
    e.stopPropagation();
  }

  onKeyDown(e) {
    const {
      onClose
    } = this.props;
    const isEsc = e.key === 'Escape';
    if (isEsc) onClose();
  }

  render() {
    const {
      classes,
      className,
      size,
      id,
      children,
      label,
      onClose
    } = this.props;
    const {
      mountStyle: visible,
      show
    } = this.state;
    const bgClasses = (0, _clsx.default)(classes.bg, {
      visible
    });
    const modalClasses = (0, _clsx.default)(className, classes[size], classes.modal, {
      visible
    });
    return show ? /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: bgClasses,
      onTransitionEnd: this.transitionEnd,
      onClick: onClose
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: modalClasses,
      onClick: this.onModalClick
    }, label ? /*#__PURE__*/_react.default.createElement("div", {
      className: classes.label
    }, /*#__PURE__*/_react.default.createElement(_Label.default, {
      fontWeight: "semibold",
      fontSize: "large",
      value: label
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.button,
      onClick: onClose
    }, "Cancel")) : null, children)) : null;
  }

}) || _class);
Modal.defaultProps = {
  visibility: true,
  size: 'medium',
  onClose: () => {}
};
var _default = Modal;
exports.default = _default;